<ng-container *ngIf="order$ | async as order">
    <h3>{{ 'aimo.orderconfirmation.thankyou' | cxTranslate }}</h3>

    <ng-container *ngFor="let entry of order.entries; index as idx">
        <aimo-cart-item [alreadyOrdered]="true" [entry]="entry" [cart]="order"></aimo-cart-item>
    </ng-container>
</ng-container>
